if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelector('.product-media-modal__nav--prev')?.addEventListener('click', (event) => {
          event.stopPropagation();
          this.showAdjacentMedia(-1);
        });
        this.querySelector('.product-media-modal__nav--next')?.addEventListener('click', (event) => {
          event.stopPropagation();
          this.showAdjacentMedia(1);
        });
        // The base media-modal click-outside-to-close handler listens on pointerup, so it must be
        // stopped there too, not just on click, or clicking a nav button also closes the modal.
        this.querySelectorAll('.product-media-modal__nav').forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });
        this.addEventListener('keyup', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowLeft') this.showAdjacentMedia(-1);
          if (event.key === 'ArrowRight') this.showAdjacentMedia(1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getVisibleMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]')).filter(
          (element) => !element.classList.contains('product__media-item--variant')
        );
      }

      activateMedia(activeMedia) {
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          if (element !== activeMedia) element.classList.remove('active');
        });
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        const visibleMedia = this.getVisibleMediaItems();
        const showNav = visibleMedia.length > 1;
        this.querySelectorAll('.product-media-modal__nav').forEach((button) => {
          button.hidden = !showNav;
        });
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        this.activateMedia(activeMedia);
      }

      showAdjacentMedia(direction) {
        const visibleMedia = this.getVisibleMediaItems();
        if (visibleMedia.length < 2) return;
        const currentIndex = visibleMedia.indexOf(this.querySelector('.product-media-modal__content > .active'));
        const nextIndex = (currentIndex + direction + visibleMedia.length) % visibleMedia.length;
        this.activateMedia(visibleMedia[nextIndex]);
      }
    }
  );
}
